import type { RedeemSubmitResult } from "@/interfaces/redeem";
import { apiClient } from "@/lib/apiClient";

/**
 * Public campaign-specific Redeem URL endpoints (Hono `redeemRoutes`, mounted at `/api/redeem`).
 * No Clerk/RBAC — the `:code` in the path is a permanent campaign code printed on physical
 * materials, and the recipient is not an authenticated user.
 */

/**
 * Page-load validation: does the campaign code resolve? Resolves on 200, REJECTS on 404 so the page
 * can render its invalid-code state. Carries no gift data — but must return a DEFINED value, since
 * TanStack Query rejects `undefined` from a query function.
 */
export async function validateRedeemCode(code: string): Promise<{ ok: true }> {
  const { data } = await apiClient.get<{ ok: true }>(`/redeem/${code}`);
  return data;
}

/**
 * Submit an email for lookup within the campaign the code identifies. Returns a STATE only (the
 * server never sends a gift link or gift detail) — the page maps it to the matching message box.
 */
export async function submitRedeemLookup(code: string, email: string): Promise<RedeemSubmitResult> {
  const { data } = await apiClient.post<RedeemSubmitResult>(`/redeem/${code}`, { email });
  return data;
}
